import { getZeroPrice } from './getZeroPrice';
import { getTotalPrice } from '../../../../utils';
export const getTotalPriceFilteredElements = (elements, type, currency) => {
    if (!(elements === null || elements === void 0 ? void 0 : elements.length)) {
        return getZeroPrice(currency);
    }
    const filteredElements = elements.filter(element => element.type === type);
    return filteredElements.length > 0
        ? getTotalPrice(filteredElements, filteredElements => filteredElements.money)
        : getZeroPrice(currency);
};
